<!-- 新建签约弹窗 -->
<template>
  <div>
    <el-dialog title="新建签约" :visible.sync="visible" width="500px" :close-on-click-modal="false" @close="handleClose">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" label-position="right">
        <el-form-item label="供应商编号" prop="userAccount">
          <el-input v-model="formData.userAccount" placeholder="请输入供应商编号" clearable :minlength="2" :maxlength="20" @blur="fetchMerchantInfo"></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="userName">
          <el-input v-model="formData.userName" :disabled="true" placeholder="请输入用户名称" clearable :minlength="2" :maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" :disabled="!formData.userName" placeholder="请输入手机号" clearable maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="签约公司" prop="signCompanyName">
          <el-input v-model="formData.signCompanyName" :disabled="true" placeholder="请先输入供应商编号"  clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addSign, getMerchantInfo, getMerchantSignCompany } from '@/api/invoiceManagement'

export default {
  name: 'SignAddDialog',
  props: {
    // 控制弹窗显示
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      visible: this.dialogVisible,
      submitLoading: false,
      formData: {
        userAccount: '',
        userName: '',
        phone: '',
        signCompanyName: ''
      },
      // 签约公司枚举
      companyOptions: [],
      rules: {
        userAccount: [
          { required: true, message: '请输入供应商编号', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 2, max: 10, message: '用户名称长度在2到10个字符之间', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        signCompanyName: [{ required: true, message: '请选择签约公司', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getCompanyEnum()
  },
  watch: {
    dialogVisible(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    async fetchMerchantInfo() {
      const { userAccount } = this.formData;
      // 只有输入框不为空时才发起请求
      if (!userAccount) {
        // 如果清空了编号，重置相关数据
        this.formData.userName = '';
        this.formData.phone = '';
        this.formData.signCompanyName = '';
        this.companyOptions = [];
        return;
      }
      try {
         // 第一步：获取供应商基础信息
        const res = await getMerchantInfo(userAccount);
        if (res.statusCode === 200 && res.data) {
          // 回填名称和电话
          this.formData.userName = res.data.name || '';
          this.formData.phone = res.data.companyNo || '';
          this.formData.signCompanyName= res.data.frgsmc || '';
        } else {
          // 如果获取供应商失败，清空数据和下拉框
          this.formData.userName = '';
          this.formData.phone = '';
          this.formData.signCompanyName = '';
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('没有查到自然人信息，请重新输入！');
      }

    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          const res = await addSign(this.formData)
          if (res.statusCode === 200) {
            this.$message.success('新建成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(res.message || '新建失败')
          }
        } catch (error) {
          console.error('新建失败', error)
          this.$message.error('新建失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    // 取消
    handleCancel() {
      this.handleClose()
    },
    // 关闭弹窗
    handleClose() {
      this.visible = false
      this.resetForm()
    },
    // // 获取签约公司枚举
    // async getCompanyEnum() {
    //   try {
    //     const res = await getCompanyEnum()
    //     if (res.statusCode === 200 && res.data) {
    //       const companyMap = {
    //         ZH: '珠海',
    //         CS: '长沙',
    //         WH: '芜湖',
    //         SJZ: '石家庄',
    //         TJ: '天津',
    //         ZZ: '郑州'
    //       }
    //       this.companyOptions = res.data.map(item => ({
    //         label: companyMap[item] || item,
    //         value: item
    //       }))
    //     }
    //   } catch (error) {
    //     console.error('获取签约公司枚举失败', error)
    //   }
    // },
    // 重置表单
    resetForm() {
      this.formData = {
        userName: '',
        phone: '',
        signCompanyName: '',
        userAccount: ''
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/contractManagement/components/SignAddDialog.vue